import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { User } from '@work4all/models/lib/Classes/User.entity';
import { UserClass } from '@work4all/models/lib/Enums/UserClass.enum';

import { IFilterPickerConfig } from '../../../../components/entity-picker/components/list-entity-picker';
import { UserPicker } from '../../../../components/entity-picker/user-picker/UserPicker';
import { FilterCard } from '../filter-card/FilterCard';

export type IUserFilterCardProps = {
  title: string;
  value: User[] | null;
  onChange: (value: User[]) => void;
  expanded: boolean;
  onExpandedChange: (val: boolean) => void;
  filterConfig?: IFilterPickerConfig;
};

export function UserFilterCard(props: IUserFilterCardProps) {
  const { title, value, onChange, expanded, onExpandedChange, filterConfig } =
    props;

  const { t } = useTranslation();

  const filterValueText: string = useMemo(() => {
    if (!value || value.length === 0) return null;
    return value.length + ' ' + t('COMMON.CHOSEN');
  }, [value, t]);

  return (
    <FilterCard
      title={title}
      filterValue={filterValueText}
      filterValueSet={!!filterValueText}
      expanded={expanded}
      onExpandedChange={onExpandedChange}
      onValueDelete={() => {
        onChange([]);
      }}
    >
      <UserPicker
        layout="advanced"
        multiple={true}
        value={value}
        onChange={(newValue) => {
          onChange(newValue);
        }}
        filterConfig={filterConfig}
        userClasses={[
          UserClass.BENUTZER,
          UserClass.MITARBEITER,
          UserClass.RESSOURCE,
        ]}
      />
    </FilterCard>
  );
}
